import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID } from '@angular/core';
import { AppComponent } from './app.component';

import { NgxMaskDirective, NgxMaskPipe, provideEnvironmentNgxMask } from 'ngx-mask';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { NgChartsModule } from 'ng2-charts';

import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import { NgHttpLoaderModule } from 'ng-http-loader';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app.routing.module';
import { ErrorsModule } from './errors/errors.module';
import { CoreModule } from './core/core.module';
import { HomeModule } from './home/home.module';
import { SegurancaModule } from './seguranca/seguranca.module';
import { MenuModule } from './shared/components/menu/menu.module';
import { ProcedimentoModule } from './procedimento/procedimento.module';
import { PrestadorModule } from './prestador/prestador.module';
import { UsuarioModule } from './usuario/usuario.module';
import { EstatisticasModule } from './estatisticas/estatisticas.module';
import { RelatorioModule } from './relatorio/relatorio.module';
import { DependenteModule } from './dependente/dependente.module';
import { ExportDataManager } from './shared/mechanism/export-data-manager.service';
import { ToastrModule } from 'ngx-toastr';

registerLocaleData(localePt);

@NgModule({ declarations: [
        AppComponent,
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        NgxMaskDirective,
        NgxMaskPipe,
        NgHttpLoaderModule.forRoot(),
        BsDatepickerModule.forRoot(),
        PopoverModule.forRoot(),
        NgChartsModule,
        MenuModule,
        ErrorsModule,
        ProcedimentoModule,
        PrestadorModule,
        UsuarioModule,
        CoreModule,
        HomeModule,
        EstatisticasModule,
        RelatorioModule,
        DependenteModule,
        SegurancaModule,
        AppRoutingModule,
        BsDatepickerModule.forRoot(),
        BrowserAnimationsModule,
        ToastrModule.forRoot()], providers: [
        { provide: LOCALE_ID, useValue: 'pt-BR' },
        ExportDataManager,
        provideEnvironmentNgxMask(),
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }
